import { Euler, MathUtils, type EulerOrder } from "three";

const { degToRad } = MathUtils;

export const toEulerFromDegrees = (
  x: number,
  y: number,
  z: number,
  order?: EulerOrder,
): Euler => new Euler(degToRad(x), degToRad(y), degToRad(z), order);
